/**
 * Shallow diff between two value snapshots.
 * Returns only keys whose value changed (by reference).
 */
export function diffValues(
  prev: Record<string, unknown>,
  next: Record<string, unknown>,
): Record<string, unknown> {
  const changed: Record<string, unknown> = {};
  const safePrev = prev ?? {};
  const safeNext = next ?? {};
  const allKeys = new Set([...Object.keys(safePrev), ...Object.keys(safeNext)]);
  for (const key of allKeys) {
    if (safePrev[key] !== safeNext[key]) {
      changed[key] = safeNext[key];
    }
  }
  return changed;
}
